import { NavigationItemType } from 'framework/navigation';
import { SET_HEADER_MENU } from './headerMenuConstants';

// eslint-disable-next-line import/prefer-default-export
export const setHeaderMenuData = (menuData: NavigationItemType[], pathname: string) => ({
  type: SET_HEADER_MENU,
  payload: {
    menuData,
    pathname,
  },
});
